import { type TFunction } from 'i18next'
import { EmailTemplate } from '#app/components/email/template.tsx'
import { ButtonLink } from '#app/components/email/ui/button-link.tsx'
import { FooterText } from '#app/components/email/ui/footer-text.tsx'
import { HeadingText } from '#app/components/email/ui/heading-text.tsx'
import { InstructionsText } from '#app/components/email/ui/instructions-text.tsx'

// Because this is an email component, it is rendered server side and does not
// behave correctly if you were to use the useTranslation hook. A translation
// function obtained via `getFixedT` must be passed in through its calling
// action in order for translations to be rendered correctly.

export function ForgotPasswordEmail({
  firstName,
  passwordResetUrl,
  t,
  baseUrl,
}: {
  firstName: string
  passwordResetUrl: string
  t: TFunction
  baseUrl: string
}) {
  const emailType = 'reset-password'
  return (
    <EmailTemplate baseUrl={baseUrl} type={emailType} t={t}>
      <HeadingText type={emailType}>
        {t('emails.forgotPassword.heading')}
      </HeadingText>

      <InstructionsText>
        {t('emails.forgotPassword.greeting', { firstName })}
      </InstructionsText>
      <InstructionsText>
        {t('emails.forgotPassword.instructions')}
      </InstructionsText>

      <ButtonLink href={passwordResetUrl}>
        {t('emails.forgotPassword.buttonText')}
      </ButtonLink>

      <FooterText>
        {t('emails.forgotPassword.backupLinkText')} {passwordResetUrl}
      </FooterText>
    </EmailTemplate>
  )
}
